<style scoped lang="less"></style>
<template>
  <div>
    <div class="page-content">
      <div class="title">设备信息</div>
      <div class="content">
        <div class="table">
          <el-table
            :data="tableData"
            stripe
            size="mini"
            border
            v-loading="pageLoading"
          >
            <el-table-column label="设备名称" align="center">
              <template slot-scope="scope">
                <router-link
                  class="font-color-theme cursor-pointer"
                  :to="
                    pbFunc.stationTypePath(
                      scope.row.device_type_code,
                      stationId,
                      scope.row.id
                    )
                  "
                  >{{ scope.row.name }}</router-link
                >
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item, key) in thTableList"
              :key="key"
              :prop="item.param"
              align="center"
              :label="item.title"
            ></el-table-column>
            <el-table-column label="状态" align="center" width="80">
              <template slot-scope="scope">
                <div :class="scope.row.statusObj.className">
                  {{ scope.row.statusObj.name }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "device",
  props: {
    tableData: Array,
    stationId: String
  },
  data() {
    return {
      pageLoading: false,
      thTableList: [
        {
          title: "是否可移动",
          param: "movableStr",
          width: ""
        },
        {
          title: "设备型号",
          param: "device_type_name",
          width: ""
        },
        {
          title: "SN",
          param: "device_sn",
          width: ""
        },
        {
          title: "监测时间",
          param: "updated_time",
          width: ""
        }
      ]
    };
  },
  //   props: ['noDataObj'],
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/device.vue